import { createSlice } from "@reduxjs/toolkit";

export const skuSlice = createSlice({
  name: "sku",
  initialState: {
    leadTime: 0,
    addCart: false,
    select: {
      // 主图
      fileName: ''
    },
    // 现货
    goods: {
      map: {},
      dispatchId: '',
      leadTime: 0,
      quantity: 0,
      isSoldOut: false,
      price: 0,
    },
    // 询盘
    inquery: {
      map: {}
    },
    // 样品
    sample: {
      map: {},
      price: 0,
      quantity: 0,
    }
  },
  reducers: {
    // 同于展示RTS标识
    setLeadTime: (state, {payload}) => {
      state.goods.leadTime = parseInt(payload);
    },
    // 更新主图
    selectSkuItem: (state, {payload}) => {
      state.select = payload;
    },
    // sku信息
    setInfoMap: (state, {payload}) => {
      const {type, info} = payload;
      state[type].map = info;
      state[type].isSoldOut = Object.values(info).reduce((a, {inventoryCount}) => a + inventoryCount, 0) === 0;
    },
    // 设置仓库
    setInventory: (state, {payload}) => {
      const {dispatchId, skuInfo, type = 'goods'} = payload;
      // 更新sku
      if (skuInfo) {
        state[type].map = skuInfo;
      }
      
      state[type].dispatchId = dispatchId;
    },
    // sku价格
    setInfoPrice: (state, {payload}) => {
      const {type, price, formatPrice, quantity, totalPrice} = payload;
      state[type].price = price;
      // 展示价格
      state[type].formatPrice = formatPrice;
      state[type].quantity = quantity;
      // 总价
      state[type].totalPrice = totalPrice;
    },
    // 无物流不展示购物车
    setAddCart: (state, {payload}) => {
      state.addCart = payload;
    },
    setTotalPrice: (state, {payload}) => {
      const {totalPrice, quantity, type} = payload;
      state[type].quantity = quantity;
      state[type].totalPrice = totalPrice;
    },
    // sku起订量
    setInfoNumber: (state, {payload}) => {
      const {type = "goods", keyword = "-1", isSoldOut = false, number} = payload;
      state[type].isSoldOut = isSoldOut;
      
      state[type].map[keyword] = {
        ...state[type].map[keyword],
        quantity: number,
        isSoldOut, 
        number,
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { selectSkuItem, setInfoMap, setInfoNumber, setInfoPrice, setLeadTime, setAddCart, setInventory, setTotalPrice } = skuSlice.actions;

export default skuSlice.reducer;
